/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface VoiceAgentInferencerCelina
 */
export interface VoiceAgentInferencerCelina {
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerCelina
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelina
   */
  name?: string | null;
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerCelina
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof VoiceAgentInferencerCelina
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof VoiceAgentInferencerCelina
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelina
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelina
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelina
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelina
   */
  domain?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerCelina
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerCelina
   */
  maxDuration?: number;
}

/**
 * Check if a given object implements the VoiceAgentInferencerCelina interface.
 */
export function instanceOfVoiceAgentInferencerCelina(value: object): value is VoiceAgentInferencerCelina {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerCelinaFromJSON(json: any): VoiceAgentInferencerCelina {
  return VoiceAgentInferencerCelinaFromJSONTyped(json, false);
}

export function VoiceAgentInferencerCelinaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerCelina {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
  };
}

export function VoiceAgentInferencerCelinaToJSON(
  value?: Omit<VoiceAgentInferencerCelina, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
  };
}
